import carmen from "../../assets/carmen.webp";
import devyn from "../../assets/devyn.webp";
import milan from "../../assets/milan.webp";
import teaghan from "../../assets/teaghan.webp";

const teamData = [
  {
    name: "Carmen Covelli-Ingwell",
    role: "Founder & CEO",
    image: carmen,
    description:
      "A passionate advocate for animal welfare and a dedicated world traveler, Carmen has seen firsthand the challenges animals face across different regions. Struggling to find proper support and resources inspired her to create the All Animal App—a platform designed to make animal care accessible everywhere, all in one place. With a deep love for community building, she believes collective action and shared knowledge can drive meaningful change. Through her work, Carmen strives to empower individuals worldwide to become stronger advocates for the animals who need them most.",
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/carmen-covelli-ingwell/",
    },
  },
  {
    name: "Devyn Ingwell",
    role: "Co-Founder",
    image: devyn,
    description:
      "Devyn Ingwell is a marketing and creative strategy professional with experience in social media management, graphic design, and copy editing. As one of the founding employees of the All Animal App, she is passionate about building a platform that empowers individuals to support animal welfare worldwide. Growing up in a home filled with animals, she developed a deep love for them early on, which continues to shape her work and personal life. Based in Spain, Devyn enjoys painting, reading, and cooking. She is a strong advocate for living an active and healthy lifestyle, and in her free time, you will find her practicing Pilates, exploring new cities, and immersing herself in different cultures.",
    socialLinks: {
      facebook: "https://www.facebook.com/devyn.ingwell",
      instagram: "https://www.instagram.com/devyni/",
      linkedin: "https://www.linkedin.com/in/devyn-ingwell/",
    },
  },
  {
    name: "Milan Ingwell",
    role: "Co-Founder",
    image: milan,
    description:
      "Milan Ingwell works in software and engineering operations in the autonomous vehicle industry. She regularly volunteers at her local animal shelter by fostering neonatal kittens and helping with their TNR (Trap-Neuter-Release) program. Milan's cat, Teeny, is a foster-fail that helps Milan with her foster kittens and travels with her wherever she goes. Between work and volunteering, you can find Milan backpacking through national parks, baking sourdough bread, or distance running.",
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/milan-ingwell-981986103/",
    },
  },
  {
    name: "Teaghan Ingwell",
    role: "Co-Founder",
    image: teaghan,
    description:
      "Teaghan is a healthcare technology professional with over 10 years of experience in data management, and business strategy & operations. In addition to her passion for helping animals, Teaghan is a strong advocate for healthy living, adventure and sports. In her free time you will find her spending time with her cat, Rue, or surfing at home or in new locations around the world.",
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/teaghan-ingwell/",
    },
  },
];

export default teamData;
